import { Link } from 'react-router-dom';
import { QUICK_SERVICES } from '../utils/homeData.js';

export default function QuickLinks() {
  return (
    <section className="bg-nkc-mist py-16 sm:py-20" id="quick-services">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Quick services</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:whitespace-nowrap sm:text-4xl">
            Everything you need, one tap away
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:gap-5">
          {QUICK_SERVICES.map((q, i) => (
            <Link
              key={q.title}
              to={q.to}
              className="v4-reveal group rounded-3xl bg-white p-5 shadow-soft transition hover:-translate-y-1 hover:shadow-lift"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              <span
                className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl text-white"
                style={{ background: q.color }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                  <path d={q.path} />
                </svg>
              </span>
              <span className="block font-display text-sm font-bold text-nkc-navy group-hover:text-nkc-blue sm:text-base">
                {q.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
